import React from 'react';
import { Card, Row, Col } from "reactstrap";
import avtarImage1 from "../../assets/images/users/avatar-1.jpg";
import { useSelector } from 'react-redux';
import moment from 'moment';

function ChartGridView({ delete_dashboard , handleViewDashboard }) {
  const {dashboard_list} = useSelector((state)=>state.Dashboard)
  return (
    <React.Fragment>
      <div
     
        className="botgrid">
        <Row className="row-cols-xxl-5 row-cols-lg-3 row-cols-1">
          
              {dashboard_list?.data?.map((element,index)=>{
                return <Col key={index} className="grid-wrap">
                <span on onClick={()=>{
                    delete_dashboard({dashboard_id:element.Dashboard_Id})
                }} className="gbd"> <i className="ri-delete-bin-line"></i></span>
                   <Card onClick={()=>{
                       handleViewDashboard({Dashboard_Id:element.Dashboard_Id})
                     }} className="card-body">
                     <div  className="d-flex mb-4 align-items-center">
                       <div className="flex-shrink-0">
                         <img
                           src={element.Dashboard_Logo}
                           alt=""
                           className="avatar-sm rounded-circle"
                         />
                       </div>
                       <div className="flex-grow-1 ms-2">
                         <h5 className="card-title mb-1">{element.Dashboard_Title}</h5>
                       </div>
                     </div>
                     <div className="grid_detail">
                       
                       <p className="card-text text-muted">{element.Dashboard_Description}</p>
                       <p className="card-text text-muted"> {element.Group_Name} </p>
                       <p className="card-text text-muted">{element.Dashboard_Category}</p>
                       <p className="card-text text-muted"></p>
                       
                       <p className="card-text text-muted">
                            {moment(element.Updated_At).format('YYYY-MM-DD')}
                       </p>
                      
                     </div>
                     
                   </Card>
                 </Col>
              })}
              
            
        </Row>
        
      </div>
    </React.Fragment>
  )
}

export default ChartGridView